import cupraConfirmation from '../../media/cupra-confirmation.png';
import cupraLogo from '../../media/cupra-logo.jpg';

const CAR_MODEL_ID = 66; // ID différent pour Cupra
// Configuration spécifique Cupra
export const cupraConfig = {
  // Configuration de l'application
  app: {
    carModelId: CAR_MODEL_ID,
    maxCommentLength: 200,
    sessionStorageKey: 'rdv_live',
    maxWorkingDaysAhead: 10,
  },

  // API Endpoints
  api: {
    calendar: `/calendar_for_business_center/${CAR_MODEL_ID}`,
    saveAppointment: 'save_appointment_for_business_center/',
  },

  // Url externes
  urlExternes: {
    rgpd: 'https://www.cupraofficial.fr/mentions-legales',
  },

  // Messages
  messages: {
    loading: 'Chargement des disponibilités...',
    loadingAvailabilities: 'Chargement des disponibilités...',
    errorLoading: 'Erreur lors du chargement des données',
    errorAppointment:
      'Nous rencontrons actuellement un problème lors de la prise de votre rendez-vous. Nous vous prions de bien vouloir réessayer ultérieurement. Nous nous excusons pour ce désagrément.',
    errorTicketNotFound: 'Rendez-vous créé, mais ticket introuvable',
    errorDataLoading: 'Impossible de charger les données.',
    errorZendeskIdMissing:
      "Impossible d'enregistrer votre rendez-vous,  merci de prendre contact avec votre conseiller automobile.",
    errorCommentInvalid:
      'Erreur : Le commentaire contient des caractères non autorisés. Veuillez modifier votre message.',
    confirmationTitle: 'Merci de votre confiance !',
    confirmationSubtitle: 'Votre rendez-vous est confirmé',
    returnToMenu: 'Retour au menu',
    returnToMainMenu: 'Revenir au menu principal',
    retry: 'Réessayer',
    dateLabel: '',
    mainTitle: 'Réservez votre rendez-vous téléphonique avec un conseiller connecté',
    timeSelectionTitle: 'Sélectionnez un créneau horaire',
    commentPlaceholder:
      'Ajoutez un commentaire à transmettre à votre conseiller',
    confirmButton: 'Confirmer ma réservation',
    breadcrumbDate: 'Date',
    breadcrumbSlot: 'Créneau',
    breadcrumbSeparator: ' > ',
    dateSimulator: 'Simulateur de date (DEV)',
    resetToToday: "Remettre à aujourd'hui",
    testConfirmation: 'Tester la confirmation',
    rgpdText:
      'Pour en savoir plus sur la gestion de vos données personnelles et pour connaître vos droits et les exercer, reportez-vous à la ',
    rgpdLinkText: 'Charte des Données Personnelles',
  },

  // Images
  images: {
    logo: cupraLogo,
    confirmation: cupraConfirmation,
  },

  // Configuration du design
  design: {
    name: 'Cupra',
    logo: cupraLogo,
    fontFamily: 'Cupra',

    // Poids de la police par type de texte
    fontWeight: {
      title: '400', // Titre principal (bold)
      subtitle: '600', // Sous-titre (semi-bold)
      body: '400', // Texte normal
      button: 'bold', // Boutons (medium)
      label: '500', // Labels (medium)
      caption: '400', // Texte secondaire
      calendarDay: '500', // Jours du calendrier (semi-bold)
      timeSlot: '500', // Créneaux horaires (semi-bold)
      timeSlotSelected: '700', // Créneaux horaires sélectionnés (black)
      calendarDate: '400', // Date du calendrier (bold)
    },

    // Taille de la police par type de texte
    fontSize: {
      title: '24px', // Titre principal
      subtitle: '18px', // Sous-titre
      body: '16px', // Texte normal
      button: '14px', // Boutons
      label: '14px', // Labels
      caption: '12px', // Texte secondaire
      calendarDay: '16px', // Jours du calendrier
      timeSlot: '16px', // Créneaux horaires
    },

    // Couleurs principales
    primaryColor: '#000000', // Noir Cupra
    secondaryColor: '#ffffff', // Blanc
    accentColor: '#f5d11f', // Jaune Cupra

    // Couleurs de texte
    textPrimary: '#000000', // Texte principal
    textSecondary: '#ffffff', // Texte secondaire
    textRgpdColor: '#707070', // Texte RGPD
    textDisabled: '#F4F4F3', // Texte désactivé
    textPlaceholder: '#b3b3b3', // Texte placeholder

    // Couleurs de fond
    backgroundPrimary: '#ffffff', // Fond principal
    backgroundSecondary: '#f5f5f5', // Fond secondaire
    backgroundHover: '#f0f0f0', // Fond au survol
    backgroundSelected: '#000000', // Fond sélectionné

    // Couleurs des bordures
    borderPrimary: 'none', // Bordure principale
    borderSecondary: '#cccccc', // Bordure secondaire
    borderFocus: '#000000', // Bordure focus

    // Couleurs d'état
    successColor: '#000000', // Vert succès
    errorColor: '#dc3545', // Rouge erreur
    warningColor: '#ffc107', // Jaune avertissement
    infoColor: '#17a2b8', // Bleu info

    // Couleurs des boutons
    buttonPrimary: '#12565D', // Bouton principal
    buttonPrimaryHover: '#12565D', // Bouton principal survol
    buttonSecondary: '#ffffff', // Bouton secondaire
    buttonSecondaryHover: '#f5f5f5', // Bouton secondaire survol
    buttonDisabled: '#cccccc', // Bouton désactivé

    // Rayon des bordures des boutons
    buttonBorderRadius: '4px', // Rayon des bordures des boutons
    calendarDayBorderRadius: '4px', // Rayon des bordures des jours du calendrier
    timeSlotBorderRadius: '4px', // Rayon des bordures des créneaux horaires

    // Couleurs du calendrier
    calendarHeader: '#666666', // En-tête calendrier
    calendarDay: '#000000', // Jour calendrier
    calendarDayHover: '#12565D', // Jour calendrier survol
    calendarDaySelected: '#000000', // Jour sélectionné
    calendarDayDisabled: '#F4F4F3', // Jour désactivé

    // Couleurs des créneaux horaires
    timeSlot: '#ffffff', // Créneau horaire
    timeSlotHover: '#12565D', // Créneau survol
    timeSlotSelected: '#12565D', // Créneau sélectionné
    timeSlotDisabled: '#F4F4F3', // Créneau désactivé
    timeSlotTextDisabled: '#838383', // Texte créneau désactivé
  },

  // Configuration des slugs
  slugs: {
    cupraFiscale: 'cupra-bc',
  },

  // Configuration des marques RDV
  marqueRdv: {
    bc: 'marquerdv_cuprabc',
  },

  // Données de test
  testData: {
    confirmationDate: '18 / 09 / 2025',
    confirmationTime: '12 : 30',
  },
};
